import api from './client';
import { Timestamp } from 'firebase/firestore';
import type { EmailSent } from 'types';

function toTimestamp(value: any): Timestamp {
  if (!value) return Timestamp.now();
  if (value instanceof Timestamp) return value;
  if (typeof value === 'string') {
    return Timestamp.fromDate(new Date(value));
  }
  if (value.seconds !== undefined) {
    return new Timestamp(value.seconds, value.nanoseconds || 0);
  }
  return Timestamp.now();
}

function apiResponseToEmailSent(response: any): EmailSent {
  return {
    ...response,
    created_at: toTimestamp(response.created_at),
    sent_at: response.sent_at ? toTimestamp(response.sent_at) : undefined,
    files: response.files || [],
  };
}

export const emailsSentApi = {
  list: async (params?: { org_id?: string; project_id?: string; is_read?: boolean; limit?: number }): Promise<EmailSent[]> => {
    const { data } = await api.get('/emails-sent', { params });
    return (data as any[]).map(apiResponseToEmailSent);
  },

  create: async (email: Omit<EmailSent, 'id' | 'created_at' | 'sent_at'> & { org_id: string }): Promise<EmailSent> => {
    const { data } = await api.post('/emails-sent', email);
    return apiResponseToEmailSent(data);
  },

  markAsRead: async (emailId: string): Promise<void> => {
    await api.patch(`/emails-sent/${emailId}/read`);
  },

  delete: async (emailId: string): Promise<void> => {
    await api.delete(`/emails-sent/${emailId}`);
  },
};
